export const CREDIT_APPLICATION_STATE_PENDING = 'PENDING'; // eslint-disable-line
